import { fetchWines } from '../api/wines';

import { GET_USER_WINES } from '../constants/wines';

export const getWines = () => async (dispatch) => {
  let wines = await fetchWines();
  dispatch({
    type: GET_USER_WINES,
    payload: wines
  });
};
